import React, { useState, useEffect, Fragment } from 'react';
import {
  Card,
  CardBody,
  CardImg,
  ButtonGroup,
  Button,
  Row,
  Modal,
  ModalHeader,
  InputGroupAddon,
  InputGroupText,
  Input,
  ModalBody,
  InputGroup,
  CustomInput
} from 'reactstrap';
import { ChromePicker } from 'react-color'
import {
  Separator,
  Colxx,
} from '../../../../../../components/common/CustomBootstrap';

import {
  colorBlockStlye,
  editingStlyeWithoutBackGround,
  SelectStyle,
  AvatarSizeStyle,
  InputStlye,
  setBackGroundColor,
} from '../../style/DigitalAssistantStyle';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

import avatars from '../../data/avatarData';
//import Avatar from './Avatar';
import ImageGallery from '../../../propinfo/gallery/index';
import { getGroupID } from '../../../../../../helpers/AxiosAPI';
import { string } from 'prop-types';
import FontsList from '../FontsList';
const quillModules = {
  toolbar: [
    ['bold', 'italic', 'underline', 'strike', 'blockquote'],
    [
      { list: 'ordered' },
      { list: 'bullet' },
      { indent: '-1' },
      { indent: '+1' },
    ],
    ['link', 'image'],
    ['clean'],
  ],
};

const quillFormats = [
  'header',
  'bold',
  'italic',
  'underline',
  'strike',
  'blockquote',
  'list',
  'bullet',
  'indent',
  'link',
  'image',
];
export default function HelpCenterDigitalAssistant({
  isVoucher = false,
  botSettings,
  saveIntegration,
  integrationId,
  locale
}) {
  console.log('botsetting', botSettings)
  /** Avatar state */
  // const [isSelected, setIsSelected] = useState({
  //   Jenni: false,
  //   Novi: false,
  //   Bob: false,
  //   Sarah: false,
  //   Wallis: false,
  // });

  const [avatarLink, setAvatarLink] = useState('');
  const [desktopIcon, setDesktopIcon] = useState('');

  //const [avatarName, setAvatarName] = useState('');
  const [galleryVisible, setGalleryVisible] = useState(false);
  /** other Digital Assistant state */
  const [edit, setEdit] = useState(true);
  let [setting, setSetting] = useState(botSettings);
  const [error, setError] = useState(true);
  const [fontsList, setFontsList] = useState({
    'title': '',
    'subTitle': '',
    'serviceTitle': '',
    'serviceDescription': '',
    'website': '',
    'buttonText': '',
    'voucherTitle': '',
    'voucherDescription': '',
  });
  const [desktopAvatar, setDesktopAvatar] = useState('');
  const [mobileAvatar, setMobileAvatar] = useState('');
  const [widgetLayout, setWidgetLayout] = useState('Rounded');
  const [desktopGalleryVisible, setDesktopGalleryVisible] = useState(false);
  const [isFooterHide, setIsFooterHide] = useState(botSettings.isFooterHide !== undefined ? botSettings.isFooterHide : false);
  const [isShowBot, setIsShowBot] = useState(botSettings.isShowChatbot !== undefined ? botSettings.isShowChatbot : false);
  const [assistantDetail, setAssistantDetail] = useState([]);
  let [iseditMode, setEditMode] = useState({
    'buttonColor': false,
    'buttonTextColor': false,
    'FrameColor': false,
  });
  useEffect(() => {

    if (botSettings) {
      setSetting(botSettings);
      //setAvatarName(botSettings.name);
      setAvatarLink(botSettings.urls.icon);
      setDesktopIcon(botSettings.urls.desktopIcon);
      setDesktopAvatar(botSettings?.sizes?.desktopAvatar);
      setMobileAvatar(botSettings?.sizes?.mobileAvatar);
      setFontsList(botSettings.fonts);
      setWidgetLayout(botSettings?.widgetLayout);
      //setIsSelected({ ...avatars, [botSettings.name]: true });
      var assistantdata = botSettings.assistantDetails.filter(i => i.locale === locale);
      if (assistantdata.length > 0) {
        setAssistantDetail({
          name: assistantdata[0].name,
          title: assistantdata[0].title,
          subTitle: assistantdata[0].subTitle,
          locale: locale
        });
      } else {
        var assistantdataEn = botSettings.assistantDetails.filter(i => i.locale === "en");
        if (assistantdataEn.length > 0) {
          setAssistantDetail({
            name: assistantdataEn[0].name,
            title: assistantdataEn[0].title,
            subTitle: assistantdataEn[0].subTitle,
            locale: locale
          });
        }
      }
    }
  }, [botSettings]);

  useEffect(() => {
    if (setting) {
      setSetting({
        ...setting,
        sizes: { ...setting.sizes, desktopAvatar: desktopAvatar, mobileAvatar: mobileAvatar },
        urls: { ...setting.urls, icon: avatarLink, desktopIcon: desktopIcon },
      });
    }
  }, [avatarLink, desktopIcon, desktopAvatar, mobileAvatar]);

  // const handleAvatarSizeChange = (e, type) => {
  //   const value = e.target.value;
  //   if (type === 'desktop') {
  //     setDesktopAvatar(value);
  //      setSetting({
  //        ...setting,
  //       sizes: { ...setting.sizes, desktopAvatar: value },

  //     });
  //   } else if (type === 'mobile') {
  //     setMobileAvatar(value);
  //      setSetting({
  //        ...setting,
  //        sizes: { ...setting.sizes, mobileAvatar: value },

  //      });
  //   }

  // };
  const handleAvatarSizeChange = (e, type) => {
    const value = e.target.value;
    if (type === 'desktop') {
      setDesktopAvatar(value);
    } else if (type === 'mobile') {
      setMobileAvatar(value);
    }
  };

  const getLocalStatement = (statements) => {
    if (statements !== undefined && statements !== null && statements.length > 0) {
      const index = statements.findIndex((m) => m.locale === locale);
      if (index === -1) {
        const englishIndex = statements.findIndex(
          (m) => m.locale === 'en'
        );
        if (englishIndex !== -1) {
          return statements[englishIndex].statement;
        }
      } else {
        return statements[index].statement;
      }
    } else {
      return '';
    }
  };
  const handleChangeCookiesText = (source, e) => {
    if (source === 'user') {
      if (setting.cookiesSetting !== null &&
        setting.cookiesSetting.text !== null && setting.cookiesSetting.text.length > 0) {
        const index = setting.cookiesSetting.text.findIndex((m) => m.locale === locale);
        var cookies = { ...setting.cookiesSetting };
        if (index === -1) {
          const newStatement = {
            statement: e,
            locale: locale,
          };
          cookies.text = [...cookies.text, newStatement];
          setSetting({
            ...setting,
            cookiesSetting: cookies,
          });
        } else {
          let newArr = [...cookies.text];
          newArr[index].statement = e;
          cookies.text = newArr;
          setSetting({
            ...setting,
            cookiesSetting: cookies,
          });
        }
      } else {
        var cookies = { ...setting.cookiesSetting };
        const newStatement = {
          statement: e,
          locale: locale,
        };
        var val = cookies.text !== null ? cookies.text : [];
        cookies.text = [...val, newStatement];
        setSetting({
          ...setting,
          cookiesSetting: cookies,
        });
      }
    }
  }
  const handleChange = (e) => {
    const value = e.target.value;
    setAssistantDetail({
      ...assistantDetail,
      [e.target.name]: value, locale: locale
    });
  };

  const handleSave = () => {
    setEdit(!edit);
    var existingDetail = setting.assistantDetails.filter(i => i.locale !== locale);
    var assitantdata = [...existingDetail, assistantDetail];
    setting.assistantDetails = assitantdata;
    setting.fonts = fontsList;
    setting.isFooterHide = isFooterHide;
    setting.isShowChatbot = isShowBot;
    saveIntegration({ botSetting: setting });
  };

  const handleChangeCookies = (e) => {
    var cookies = { ...setting.cookiesSetting };
    cookies.isShowCookies = e.target.checked;
    setSetting({ ...setting, cookiesSetting: cookies });
  }
  const handleCheckedBookingButton = (e) => {
    setSetting({ ...setting, isBookingButtonHide: e.target.checked });
  }
  //greyscale
  const handleCheckedGreyscaleButton = (e) => {

    setSetting({ ...setting, isGreyScale: e.target.checked });

  }
  const handleWidgetLayout = (e) => {

    const newLayout = e.target.value;
    setWidgetLayout(newLayout);
    setSetting(prevSetting => ({
      ...prevSetting,
      widgetLayout: newLayout,
    }));
  }
  const togglegallery = () => {
    setGalleryVisible(!galleryVisible);
  };
  const toggledesktopgallery = () => {
    setDesktopGalleryVisible(!desktopGalleryVisible);
  };
  const selectedImage = (image) => {
    if (image !== undefined) {
      setAvatarLink(image.src);
    }
  };
  const selectedDesktopImage = (image) => {
    if (image !== undefined) {
      setDesktopIcon(image.src);
    }
  };
  const SetClose = () => {
    setEditMode({
      'buttonColor': false,
      'buttonTextColor': false,
      'FrameColor': false
    });
  };
  const CloseColorBox = (event) => {
    if ((iseditMode.buttonColor === true ||
      iseditMode.buttonTextColor === true ||
      iseditMode.FrameColor === true)) {
      SetClose();
    }
  };

  const ImageGalleryButton = () => {
    return (
      <Row>
        <Colxx xs="12" sm="12" md="12" lg="12" className="mb-4">
          <Row>
            <Colxx xs="12" sm="3" className="mb-1">
              <Modal
                isOpen={galleryVisible}
                toggle={togglegallery}
                style={{ maxWidth: '1000px' }}
              >
                <ModalHeader toggle={togglegallery}>Select Avatar</ModalHeader>
                <ModalBody>
                  <ImageGallery
                    selectedImage={selectedImage}
                    togglegallery={togglegallery}
                    hideUserUploads={false}
                    searchText={'avatar'}
                  />
                </ModalBody>
              </Modal>
            </Colxx>
          </Row>
        </Colxx>
      </Row>
    );
  };

  const ImageDesktopGalleryButton = () => {
    return (
      <Row>
        <Colxx xs="12" sm="12" md="12" lg="12" className="mb-4">
          <Row>
            <Colxx xs="12" sm="3" className="mb-1">
              <Modal
                isOpen={desktopGalleryVisible}
                toggle={toggledesktopgallery}
                style={{ maxWidth: '1000px' }}
              >
                <ModalHeader toggle={toggledesktopgallery}>Select Image</ModalHeader>
                <ModalBody>
                  <ImageGallery
                    selectedImage={selectedDesktopImage}
                    togglegallery={toggledesktopgallery}
                    hideUserUploads={false}
                    searchText={''}
                  />
                </ModalBody>
              </Modal>
            </Colxx>
          </Row>
        </Colxx>
      </Row>
    );
  };
  //console.log(setting);
  return (
    <Fragment>
      {setting ? (
        <Card>
          <CardBody name="bodyClick" onClick={(e) => { CloseColorBox(e); }}>
            <div className="text-center">
              <h6>Website Widget Appearance</h6>
              <Separator className="mb-3" />
              <Row>
                <Colxx md={6}>
                  <b>Assistant Icon</b><br />
                  <CardImg
                    top
                    src={avatarLink}
                    alt="Card image cap"
                    className="img-thumbnail border-0 rounded-circle list-thumbnail"
                  />
                  <div className="mb-1">
                    <Button
                      color="success"
                      size="xs"
                      className="mt-1"
                      onClick={togglegallery}
                    >
                      Browse Avatars
                    </Button>
                  </div>
                </Colxx>
                <Colxx md={6}>
                  <b>Desktop Icon</b><br />
                  <CardImg
                    style={{ maxWidth: "90px !important" }}
                    top
                    src={desktopIcon === null || desktopIcon === "" ? "https://via.placeholder.com/250x150" : desktopIcon}
                    alt="Card image cap"
                    className="img-thumbnail border-0 rounded-circle list-thumbnail mt-2 image-width"
                  />
                  <div className="mb-1">
                    <Button
                      color="success"
                      size="xs"
                      className="mt-1"
                      onClick={toggledesktopgallery}
                    >
                      Browse Image
                    </Button>
                  </div>
                </Colxx>
              </Row>
              <div className="mb-1">
                <b>Assistant Name</b>
                <br />
                <input
                  name="name"
                  style={InputStlye}
                  defaultValue={assistantDetail.name}
                  placeholder={assistantDetail.name}
                  onChange={handleChange}
                />
              </div>
              <div className="my-2">
                <b>Title</b>
                <br />
                <input
                  name="title"
                  style={InputStlye}
                  defaultValue={assistantDetail.title}
                  onChange={handleChange}
                />
              </div>

              <div className="mb-1">
                <b>Subtitle</b>
                <br />
                <input
                  name="subTitle"
                  style={InputStlye}
                  defaultValue={assistantDetail.subTitle}
                  onChange={handleChange}
                />
              </div>
            </div>
            {/* Avatar Size Inputs */}
            <div className="row mb-2 mt-4 text-center " style={{ margin: '0px 40px' }}>
              <div className=" text-center col-md-6 mb-1">
                <b>Desktop Avatar Size (px)</b>
                <br />
                <input
                  name="desktopAvatar"
                  type="number"
                  style={SelectStyle}
                  value={desktopAvatar}
                  min={30}
                  max={80}
                  onChange={(e) => handleAvatarSizeChange(e, 'desktop')}
                  placeholder=""
                />
                <p><span style={{ color: '#A9A9A9' }}>Default: 70px</span></p>
              </div>
              <div className=" text-center col-md-6 mb-1">
                <b>Mobile Avatar Size (px)</b>
                <br />
                <input
                  name="mobileAvatarSize"
                  type="number"
                  style={SelectStyle}
                  value={mobileAvatar}
                  min={30}
                  max={80}
                  onChange={(e) => handleAvatarSizeChange(e, 'mobile')}
                  placeholder=""
                />
                <p> <span style={{ color: '#A9A9A9' }}>Default: 70px</span></p>
              </div>
            </div>
            <div className="row mb-2 mt-4 text-center " style={{ margin: '0px 40px' }}>
              <div className=" text-center col-md-6 mb-1">
                {setting.fonts !== undefined && (
                  <div className=''>

                    <b>Widget Layout</b>

                    <br />

                    <select
                      name="Widget Layout"
                      type='select'
                      style={SelectStyle}

                      value={widgetLayout}
                      onChange={(e) => handleWidgetLayout(e)}
                    >

                      <option value='Rounded' > Rounded </option>

                      <option value='Square Edges'>Square Edges </option>
                    </select>
                    <p><span style={{ color: '#A9A9A9' }}>Default: Rounded</span></p>


                  </div>
                )}
              </div>
              <div className=" text-center col-md-6 mb-1">
                {setting.fonts !== undefined && (
                  <div className=''>

                    <b>Website Font Name </b>

                    <br />
                    <div className="">
                      <FontsList InputStlye={SelectStyle} value={setting.fonts.website} settings={setting} setFont={(e) => setFontsList({ ...fontsList, website: e.target.value })}></FontsList>
                    </div>
                  </div>

                )}
              </div>

            </div>
            <div className="text-left mt-4">
              {/* <div className="mb-1 text-center"><b>Colour Settings</b></div> */}
              <div style={{ padding: '0 5%' }}>
                <Row>
                  <Colxx xxs="6">
                    <div >
                      <div className='row mb-2' onClick={(e) => { e.stopPropagation(); }}>
                        <div className='col-md-6 text-left' style={{
                          marginTop: '0.30rem'
                        }}><span className=''>Button Color</span></div>
                        <div className='col-md-6'>
                          <InputGroup>
                            <Input
                              className=""
                              type="text"
                              onChange={(e) => {
                                let colours = setting.colours;
                                colours.buttonColor = e.target.value;
                                setSetting({ ...setting, colours: colours });
                              }}
                              value={setting.colours.buttonColor}
                            />
                            <InputGroupAddon addonType="append">
                              <InputGroupText onClick={() => {
                                setEditMode({ ...iseditMode, buttonColor: !iseditMode.buttonColor });
                              }
                              } className="color-square" style={setBackGroundColor(setting.colours.buttonColor)}></InputGroupText>
                            </InputGroupAddon>
                          </InputGroup>
                        </div>
                      </div>
                    </div>
                    {iseditMode.buttonColor && <div className='parent-div'>
                      <div className='cover' onClick={(e) => { e.stopPropagation(); }}>
                        <ChromePicker disableAlpha={true} className='ml-2'
                          style={{ width: '240px' }}
                          color={setting.colours.buttonColor}
                          onChangeComplete={(e) => {

                            if (edit) {
                              let colours = setting.colours;
                              colours.buttonColor = e.hex;
                              setSetting({ ...setting, colours: colours });
                              setEditMode({ ...iseditMode, buttonColor: false });
                            } else setError(true);
                          }
                          }
                        />
                      </div>
                    </div>}
                  </Colxx>

                  <Colxx xxs="6">
                    <div >
                      <div className='row mb-2' onClick={(e) => { e.stopPropagation(); }}>
                        <div className='col-md-6 text-left' style={{
                          marginTop: '0.30rem'
                        }}><span className=''>Button Text Color</span></div>
                        <div className='col-md-6'>
                          <InputGroup>
                            <Input
                              className=""
                              type="text"
                              onChange={(e) => {
                                let colours = setting.colours;
                                colours.buttonTextColor = e.target.value;
                                setSetting({ ...setting, colours: colours });
                              }}
                              value={setting.colours.buttonTextColor}
                            />
                            <InputGroupAddon addonType="append">
                              <InputGroupText onClick={() => {
                                setEditMode({ ...iseditMode, buttonTextColor: !iseditMode.buttonTextColor });
                              }
                              } className="color-square" style={setBackGroundColor(setting.colours.buttonTextColor)}></InputGroupText>
                            </InputGroupAddon>
                          </InputGroup>
                        </div>
                      </div>
                    </div>
                    {iseditMode.buttonTextColor && <div className='parent-div'>
                      <div className='cover' onClick={(e) => { e.stopPropagation(); }}>
                        <ChromePicker disableAlpha={true} className='ml-2'
                          style={{ width: '240px' }}
                          color={setting.colours.buttonTextColor}
                          onChangeComplete={(e) => {
                            if (edit) {
                              let colours = setting.colours;
                              colours.buttonTextColor = e.hex;
                              setSetting({ ...setting, colours: colours });
                              setEditMode({ ...iseditMode, buttonTextColor: false });
                            } else setError(true);
                          }}
                        />
                      </div>
                    </div>}
                  </Colxx>
                  <Colxx xxs="6">
                    <div>
                      <div className='row mb-2' onClick={(e) => { e.stopPropagation(); }}>
                        <div className='col-md-6 text-left' style={{ marginTop: '0.30rem' }}>
                          <span className=''>Frame Color</span>
                        </div>
                        <div className='col-md-6'>
                          <InputGroup>
                            <Input
                              className=""
                              type="text"
                              onChange={(e) => {
                                let colours = setting.colours;
                                colours.frameColor = e.target.value;
                                setSetting({ ...setting, colours: colours });
                              }}
                              value={setting.colours.frameColor}
                            />
                            <InputGroupAddon addonType="append">
                              <InputGroupText onClick={() => {
                                setEditMode({ ...iseditMode, FrameColor: !iseditMode.FrameColor });
                              }
                              } className="color-square" style={setBackGroundColor(setting.colours.frameColor)}></InputGroupText>
                            </InputGroupAddon>
                          </InputGroup>
                        </div>
                      </div>
                    </div>
                    {iseditMode.FrameColor && <div className='parent-div'>
                      <div className='cover' onClick={(e) => { e.stopPropagation(); }}>
                        <ChromePicker disableAlpha={true} className='ml-2'
                          style={{ width: '240px' }}
                          color={setting.colours.frameColor}
                          onChangeComplete={(e) => {
                            if (edit) {
                              let colours = setting.colours;
                              colours.frameColor = e.hex;
                              setSetting({ ...setting, colours: colours });
                              setEditMode({ ...iseditMode, FrameColor: false });
                            } else setError(true);
                          }}
                        />
                      </div>
                    </div>}
                  </Colxx>
                </Row>
                {/* <div className="my-2 mt-3 text-center"><b>Font Settings</b></div> */}

                <div className='d-flex my-3' style={{ justifyContent: "space-between" }}>
                  {/* <CustomInput
                    key="isFooterBmb"
                    type="checkbox"
                    checked={isFooterHide}
                    onChange={(e) => e.target.checked === true ? setIsFooterHide(true) : setIsFooterHide(false)}
                  ><span>Remove "Empowered by Myma.ai"</span></CustomInput> */}
                  <CustomInput
                    key="isShowBot"
                    type="checkbox"
                    checked={isShowBot}
                    onChange={(e) => e.target.checked === true ? setIsShowBot(true) : setIsShowBot(false)}
                  ><span>Show Chat Only</span></CustomInput>
                </div>
                <div className='row my-3'>
                  <div className='col-md-12'>
                    <CustomInput
                      key="isBookingButtonHide"
                      type="checkbox"
                      checked={setting.isBookingButtonHide}
                      onChange={(e) => handleCheckedBookingButton(e)}
                    ><span>Hide Booking Engine Button</span></CustomInput>
                  </div>
                </div>
                <div className='row'>
                  <div className='col-md-12'>
                    <CustomInput
                      key="isShowCookies"
                      type="checkbox"
                      checked={setting.cookiesSetting.isShowCookies}
                      onChange={(e) => handleChangeCookies(e)}
                    ><span>Show Privacy/Cookies popup</span></CustomInput>
                  </div>
                  {setting.cookiesSetting !== null && setting.cookiesSetting.isShowCookies &&
                    <div className='col-md-12'>
                      <ReactQuill
                        theme="snow"
                        value={getLocalStatement(setting.cookiesSetting.text)}
                        onChange={(content, delta, source) =>
                          handleChangeCookiesText(source, content)
                        }
                        modules={quillModules}
                        formats={quillFormats}
                        name="text"
                      />
                    </div>
                  }
                </div>
                <div className='row my-3'>
                  <div className='col-md-12'>
                    <CustomInput
                      key="isGreyScale"
                      type="checkbox"
                      checked={setting.isGreyScale}
                      onChange={(e) => handleCheckedGreyscaleButton(e)}
                    ><span>Show Empowered by Myma.ai in Greyscale</span></CustomInput>
                  </div>
                </div>
              </div>
              <div className='text-center'>
                <ButtonGroup className="mb-2 " style={{ marginTop: '40px' }}>
                  <Button color="primary" size="xs" outline onClick={handleSave}>
                    Save
                  </Button>
                  <Button
                    size="xs"
                    color="dark"
                    outline
                    onClick={() => {
                      CloseColorBox();
                    }}
                  >
                    Cancel
                  </Button>
                </ButtonGroup>
              </div>
            </div>
          </CardBody>
        </Card >
      ) : null
      }
      {ImageGalleryButton()}
      {ImageDesktopGalleryButton()}

    </Fragment >
  );
}

